import React, { useRef, useMemo } from 'react';
import { useFrame } from '@react-three/fiber';
import { Sphere, MeshDistortMaterial } from '@react-three/drei';
import { Color } from 'three';

function Rock({ color }) {
  const mesh = useRef();
  const speed = useMemo(() => Math.random() * 0.3 + 0.05, []); // Random speed for each rock
  const maxRadius = 1.5; // Maximum radius of the circular path
  const initialPhase = useMemo(() => Math.random() * 2 * Math.PI, []); // Random initial phase for each rock
  const verticalPosition = useMemo(() => Math.random() * 4.5 - 2.5, []); // Random vertical position for each rock

  useFrame((state) => {
    if (mesh.current) {
      // Calculate the current radius based on the elapsed time and initial phase
      const radius = maxRadius * (1 + Math.sin(state.clock.getElapsedTime() * speed + initialPhase)) / 2;
      mesh.current.position.x = radius * Math.cos(state.clock.getElapsedTime() * speed + initialPhase);
      mesh.current.position.z = radius * Math.sin(state.clock.getElapsedTime() * speed + initialPhase);
      mesh.current.position.y = verticalPosition * Math.sin(state.clock.getElapsedTime() * speed / 3);
    }
  });

  return (
    <Sphere ref={mesh} args={[0.06, 6, 6]}>
      <MeshDistortMaterial color={color}
        distort={0}
        radius={1}
        envMapIntensity={2.0} // Increased from 1.2 for more brightness
        iridescence={1}
        iridescenceIOR={1}
        iridescenceThicknessRange={[0, 800]}
        clearcoat={5.0} // Increase for more shine
        clearcoatRoughness={0}
        metalness={0.2} 
        roughness={0.6}
        transparent={true}
        opacity={0.9} // Default opacity for inactive bubbles
        refractionRatio={0.5}
        transmission={0.7}  />
    </Sphere>
  );
}

export default function Aquarium() {
  const rocks = new Array(32).fill(null); // Create 24 rocks

  return (
    <group position={[0.1, 0, -0.5]}>
      {rocks.map((_, i) => (
        <Rock key={i} color={new Color(`hsl(${(i / rocks.length) * 360}, 100%, 50%)`)} />
      ))}
    </group>
  );
}